import React, { useState } from 'react';
import { useLocalContext } from '../../context/LocalContext';
import './Auth.css';

const LoginModal = () => {
  const { 
    isLoginModalOpen, 
    closeLoginModal, 
    openSignupModal, 
    login, 
    isLoading, 
    formData, 
    updateFormData,
    showNotification 
  } = useLocalContext();

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email';
    }
    
    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;
    
    const result = await login(formData.email, formData.password);
    
    if (!result.success) {
      showNotification(result.error || 'Login failed', 'error');
    }
  };

  const handleClose = () => {
    closeLoginModal();
    setErrors({});
  };

  const switchToSignup = () => {
    closeLoginModal();
    openSignupModal();
  };

  if (!isLoginModalOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={handleClose}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="modal-header">
          <div className="modal-logo">
            <svg viewBox="0 0 100 30" className="tinder-logo-modal">
              <g fill="currentColor">
                <path d="M10.5 5.5c-.2-.4-.6-.7-1.1-.7H7.2c-.5 0-.9.3-1.1.7L.1 18.3c-.2.4-.1.8.1 1.1.2.3.6.5 1 .5h2.4c.5 0 .9-.3 1.1-.7l5.8-13.6c.2-.4.1-.8 0-1.1z"/>
                <path d="M23.5 5.5c-.2-.4-.6-.7-1.1-.7h-2.2c-.5 0-.9.3-1.1.7l-6 13.9c-.2.4-.1.8.1 1.1.2.3.6.5 1 .5h2.4c.5 0 .9-.3 1.1-.7l5.8-13.6c.2-.4.1-.8 0-1.2z"/>
                <path d="M36.2 5.5c-.2-.4-.6-.7-1.1-.7h-2.2c-.5 0-.9.3-1.1.7l-6 13.9c-.2.4-.1.8.1 1.1.2.3.6.5 1 .5h2.4c.5 0 .9-.3 1.1-.7l5.8-13.6c.2-.4.1-.8 0-1.2z"/>
                <path d="M48.7 8.4c.4 0 .8-.2 1-.5l1.4-2.1c.2-.3.2-.7.1-1-.2-.3-.5-.5-.9-.5H38c-.4 0-.7.2-.9.5-.2.3-.2.7-.1 1l1.4 2.1c.2.3.6.5 1 .5h2.8v11.5c0 .6.4 1 1 1h2.5c.6 0 1-.4 1-1V8.4h2zm12.6-3.6h-2.5c-.6 0-1 .4-1 1v13.1c0 .6.4 1 1 1h2.5c.6 0 1-.4 1-1V5.8c0-.6-.4-1-1-1zm15.8 0h-2.5c-.6 0-1 .4-1 1v7.7l-6.1-8.2c-.2-.3-.5-.5-.9-.5h-2.1c-.6 0-1 .4-1 1v13.1c0 .6.4 1 1 1h2.5c.6 0 1-.4 1-1v-7.7l6.1 8.2c.2.3.5.5.9.5h2.1c.6 0 1-.4 1-1V5.8c0-.6-.4-1-1-1zm14.5 0H82c-.4 0-.7.2-.9.5-.2.3-.2.7-.1 1l1.4 2.1c.2.3.6.5 1 .5h2.8v11.5c0 .6.4 1 1 1h2.5c.6 0 1-.4 1-1V8.4h2.8c.4 0 .8-.2 1-.5l1.4-2.1c.2-.3.2-.7.1-1-.2-.3-.5-.5-.9-.5z"/>
              </g>
            </svg>
          </div>
          <h2 className="modal-title">Welcome back</h2>
          <p className="modal-subtitle">Log in to continue your journey</p>
        </div>

        <form className="modal-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="login-email">Email</label>
            <input
              type="email"
              id="login-email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={(e) => updateFormData('email', e.target.value)}
              className={errors.email ? 'error' : ''}
            />
            {errors.email && <span className="error-text">{errors.email}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="login-password">Password</label>
            <div className="password-input">
              <input
                type={formData.showPassword ? 'text' : 'password'}
                id="login-password"
                placeholder="Enter your password"
                value={formData.password}
                onChange={(e) => updateFormData('password', e.target.value)}
                className={errors.password ? 'error' : ''}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => updateFormData('showPassword', !formData.showPassword)}
              >
                {formData.showPassword ? (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
            {errors.password && <span className="error-text">{errors.password}</span>}
          </div>

          <a href="#" className="forgot-link">Forgot password?</a>

          <button type="submit" className="btn btn-primary btn-block btn-lg" disabled={isLoading}>
            {isLoading ? (
              <span className="loading-spinner"></span>
            ) : (
              'Log in'
            )}
          </button>
        </form>

        <div className="modal-divider">
          <span>or</span>
        </div>

        <div className="social-login">
          <button className="social-btn google">
            <svg viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continue with Google
          </button>
          <button className="social-btn facebook">
            <svg viewBox="0 0 24 24" fill="#1877F2">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            Continue with Facebook
          </button>
        </div>

        <div className="modal-footer">
          <p>
            Don't have an account?{' '}
            <button className="link-btn" onClick={switchToSignup}>
              Sign up
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
